import axiosInstance from "./AxiosInstance";

class UTDService {
  // Method to get siteId - now expects it to be passed in rather than using static mapping
  getSiteId(siteId) {
    return siteId || "";
  }

  async getProducts(label, lang = "nl", siteId) {
    if (!siteId) {
      throw new Error('siteId is required for getProducts');
    }

    const url = `/site-builder/meta-details?siteId=${siteId}&label=${label}&limit=9999&order=priority`;

    try {
      const { data } = await axiosInstance.get(url);
      const products = data.payload.results;
      return products;
    } catch (e) {
      console.error('Error fetching products:', e);
      throw e;
    }
  }

  async getVacations(options = {}) {
    const {
      label = 'vakanties',
      lang = 'nl',
      limit = 9999,
      offset = 0,
      order = 'priority',
      siteId
    } = options;

    if (!siteId) {
      throw new Error('siteId is required for getVacations');
    }
    
    const url = `/site-builder/meta-details?siteId=${siteId}&label=${label}&limit=${limit}&offset=${offset}&order=${order}`;

    try {
      const { data } = await axiosInstance.get(url);
      return {
        results: data.payload.results,
        total: data.payload.total,
        limit: data.payload.limit,
        offset: data.payload.offset
      };
    } catch (e) {
      console.error('Error fetching vacations:', e);
      throw e;
    }
  }

  async searchVacations(searchQuery, options = {}) {
    const vacations = await this.getVacations(options);
    
    if (!searchQuery) {
      return vacations;
    }

    const query = searchQuery.toLowerCase();
    const filteredResults = vacations.results.filter(vacation => 
      vacation.metadata.title.toLowerCase().includes(query) ||
      vacation.name.toLowerCase().includes(query) ||
      vacation.metadata.categories.some(cat => cat.toLowerCase().includes(query))
    );

    return {
      ...vacations,
      results: filteredResults,
      total: filteredResults.length
    };
  }
}

export default new UTDService();
